import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import AppConstants from "../../../Constants/AppConstants";
const AddHersteller = (props) => {
  const {
    herstellerDetails,
    closeAddEditHerstellerPopUpCallback,
    equipmentGrpName,
  } = props;
  const [herstellerName, setHerstellerName] = useState("");
  const [eigenherstellung, setEigenherstellung] = useState(false);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    setHerstellerName(herstellerDetails ? herstellerDetails.hersteller : "");
    setEigenherstellung(herstellerDetails.eigenHerstellung ? true : false);
  }, [props]);

  const herstellerAdd = (e) => {
    e.preventDefault();
    const hersteller = {
      ID: herstellerDetails ? herstellerDetails.id : AppConstants.DEFAULT_GUID,
      Hersteller: herstellerName.trim(),
      EigenHerstellung: eigenherstellung,
    };
    setGlobalSpinner(true);
    herstellerDetails && herstellerDetails.id != ""
      ? commonUtils.setIsEdit(true)
      : commonUtils.setIsEdit(false);
    EquipmentGroupActions.addOrUpdateHerstelleres(hersteller);
  };

  function handleClosePopOver() {
    if (!herstellerDetails) {
      setHerstellerName("");
      setEigenherstellung(false);
    }
    closeAddEditHerstellerPopUpCallback();
  }
  return (
    <div
      className={`modal fade   ${equipmentGrpName ? "nestedPopover" : ""}`}
      id="addHersteller"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addHersteller"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div
        className={`modal-dialog   ${
          equipmentGrpName ? "nestedPopverMargin" : ""
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addHersteller">
              {herstellerDetails
                ? localization.editHersteller
                : localization.addHersteller}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addHerstellerModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="herstellerAdd" autoComplete="off" onSubmit={herstellerAdd}>
            <div className="modal-body">
              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="hersteller">
                  {localization.herstellerName}
                </label>
                <input
                  type="text"
                  id="hersteller"
                  name="hersteller"
                  className="form-control"
                  required
                  placeholder={localization.herstellerName}
                  value={herstellerName}
                  onChange={(e) => {
                    e.preventDefault();
                    if (herstellerName !== "") {
                      setHerstellerName(e.target.value);
                    } else {
                      setHerstellerName(e.target.value.trim());
                    }
                  }}
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="hersteller">
                  {localization.inHouseProduction}
                </label>
                <select
                  className="form-control"
                  id="eigenherstellung"
                  name="eigenherstellung"
                  value={eigenherstellung}
                  onChange={(e) => {
                    setEigenherstellung(e.target.value);
                  }}
                >
                  <option value="true">{localization.yes}</option>
                  <option value="false">{localization.no}</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddHersteller;
